
import { Component, Vue } from "vue-property-decorator";
import ClientsTable from "@/components/client/ClientsTable.vue";

@Component({
  name: "clients-page",
  components: { ClientsTable },
})
export default class ClientsPage extends Vue {
  constructor() {
    super();
  }

  goToAddClient = async (): Promise<void> => {
    await this.$router.push({
      name: "add-client",
    });
  };
}
